// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"4b25139a","787":"56230587"}[chunkId] + ".chunk.js";
};